import { defineComponent } from 'vue-demi';
import { s as script$1 } from './OrIcon-22d7aeff.js';
import { resolveComponent, openBlock, createElementBlock, normalizeClass, createElementVNode, mergeProps, withModifiers, normalizeStyle, createVNode, Transition, withCtx, createBlock, createCommentVNode, renderSlot, createTextVNode, toDisplayString } from 'vue';
import { s as styleInject } from './style-inject.es-4c6f2515.js';

var script = defineComponent({
  name: 'OrCheckbox',
  components: {
    OrIcon: script$1
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: null,
      default: null,
      required: false
    },
    withState: {
      type: Boolean,
      default: false,
      required: false
    },
    value: {
      type: null,
      default: null,
      required: false
    },
    label: {
      type: String,
      default: '',
      required: false
    },
    isDisabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  emits: ['update:modelValue', 'focus', 'blur'],
  computed: {
    isArrayModelValue() {
      return Array.isArray(this.modelValue);
    },
    rootClasses() {
      return ['or-checkbox', {
        'is-checked': this.isChecked,
        'is-disabled': this.isDisabled
      }];
    },
    hasContent() {
      return this.$slots.default || this.label;
    },
    isChecked() {
      var _a;
      if (this.isArrayModelValue) {
        return this.modelValue.includes(this.value);
      }
      if (this.withState) return (_a = this.modelValue) === null || _a === void 0 ? void 0 : _a.icon;
      return !!this.modelValue;
    }
  },
  methods: {
    onChange({
      target
    }) {
      if (this.isDisabled || this.withState) return;
      const isChecked = target.checked;
      if (this.isArrayModelValue) {
        const newValue = [...this.modelValue];
        isChecked ? newValue.push(this.value) : newValue.splice(newValue.indexOf(this.value), 1);
        this.$emit('update:modelValue', newValue);
      } else {
        this.$emit('update:modelValue', isChecked);
      }
    },
    onClick() {
      if (!this.withState) return;
      this.$emit('update:modelValue', this.modelValue);
    }
  }
});

const _hoisted_1 = ["checked", "disabled", "value"];
const _hoisted_2 = {
  key: 2,
  class: "or-checkbox--content"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_or_icon = resolveComponent("or-icon");
  return openBlock(), createElementBlock("label", {
    class: normalizeClass(_ctx.rootClasses)
  }, [createElementVNode("input", mergeProps(_ctx.$attrs, {
    checked: _ctx.isChecked,
    disabled: _ctx.isDisabled,
    value: _ctx.value,
    type: "checkbox",
    class: "or-checkbox--input visually-hidden",
    onChange: _cache[0] || (_cache[0] = (...args) => _ctx.onChange && _ctx.onChange(...args)),
    onFocus: _cache[1] || (_cache[1] = $event => _ctx.$emit('focus', $event)),
    onBlur: _cache[2] || (_cache[2] = $event => _ctx.$emit('blur', $event)),
    onClick: _cache[3] || (_cache[3] = withModifiers((...args) => _ctx.onClick && _ctx.onClick(...args), ["stop"]))
  }), null, 16 /* FULL_PROPS */, _hoisted_1), !_ctx.withState ? (openBlock(), createElementBlock("span", {
    key: 0,
    style: normalizeStyle(!_ctx.hasContent ? {
      marginRight: 0
    } : null),
    class: "or-checkbox--checkbox"
  }, [createVNode(Transition, {
    name: "fade",
    mode: "out-in"
  }, {
    default: withCtx(() => [_ctx.isChecked ? (openBlock(), createBlock(_component_or_icon, {
      key: 0,
      class: "or-checkbox--icon",
      icon: "done"
    })) : createCommentVNode("v-if", true)]),
    _: 1 /* STABLE */
  })], 4 /* STYLE */)) : (openBlock(), createElementBlock("span", {
    key: 1,
    style: normalizeStyle(!_ctx.hasContent ? {
      marginRight: 0
    } : null),
    class: "or-checkbox--checkbox"
  }, [createVNode(Transition, {
    name: "fade",
    mode: "out-in"
  }, {
    default: withCtx(() => [(openBlock(), createBlock(_component_or_icon, {
      key: _ctx.modelValue.icon,
      icon: _ctx.modelValue.icon
    }, null, 8 /* PROPS */, ["icon"]))]),
    _: 1 /* STABLE */
  })], 4 /* STYLE */)), _ctx.hasContent ? (openBlock(), createElementBlock("span", _hoisted_2, [renderSlot(_ctx.$slots, "default", {}, () => [createTextVNode(toDisplayString(_ctx.label), 1 /* TEXT */)])])) : createCommentVNode("v-if", true)], 2 /* CLASS */);
}

var css_248z = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-22a147d8 {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-22a147d8 {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n.or-checkbox[data-v-22a147d8] {\n  display: inline-flex;\n  align-items: center;\n  font-size: var(--fs-1);\n  line-height: 1rem;\n  color: inherit;\n  cursor: pointer;\n}\n.or-checkbox--checkbox[data-v-22a147d8] {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1rem;\n  min-width: 1rem;\n  height: 1rem;\n  min-height: 1rem;\n  margin-right: var(--s-3);\n  background-color: var(--c-white);\n  border: 1px solid var(--c-neutral-2);\n  border-radius: 2px;\n  transition-timing-function: var(--t-func);\n  transition-duration: var(--t-duration);\n  transition-property: background-color, border-color;\n}\n.or-checkbox[data-v-22a147d8] .or-icon {\n  font-size: 1rem;\n  color: var(--c-white);\n  transition-timing-function: var(--t-func);\n  transition-duration: var(--t-duration);\n  transition-property: color;\n}\n@media (hover: hover) and (pointer: fine) {\n.or-checkbox:not(.or-checkbox.is-loading):not(.or-checkbox.is-disabled):not(.or-checkbox.is-readonly):not(.or-checkbox:disabled):not(.or-checkbox.is-focused):not(.or-checkbox:active):hover .or-checkbox--checkbox[data-v-22a147d8] {\n    border-color: var(--c-neutral-2-darken-3);\n}\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n.or-checkbox:not(.or-checkbox.is-loading):not(.or-checkbox.is-disabled):not(.or-checkbox.is-readonly):not(.or-checkbox:disabled):not(.or-checkbox.is-focused):not(.or-checkbox:active):hover .or-checkbox--checkbox[data-v-22a147d8] {\n    border-color: var(--c-neutral-2-darken-3);\n}\n}\n.or-checkbox:not(:disabled):not(.is-loading):not(.is-disabled):not(.is-readonly):active .or-checkbox--checkbox[data-v-22a147d8] {\n  border-color: var(--c-neutral-2-darken-5);\n}\n.or-checkbox[data-v-22a147d8]:disabled, .or-checkbox.is-disabled[data-v-22a147d8] {\n  cursor: not-allowed;\n}\n.or-checkbox.is-checked .or-checkbox--checkbox[data-v-22a147d8] {\n  background-color: var(--c-primary);\n  border-color: var(--c-primary);\n}\n@media (hover: hover) and (pointer: fine) {\n.or-checkbox.is-checked:not(.or-checkbox.is-checked.is-loading):not(.or-checkbox.is-checked.is-disabled):not(.or-checkbox.is-checked.is-readonly):not(.or-checkbox.is-checked:disabled):not(.or-checkbox.is-checked.is-focused):not(.or-checkbox.is-checked:active):hover .or-checkbox--checkbox[data-v-22a147d8] {\n    background-color: var(--c-primary-darken-3);\n    border-color: var(--c-primary-darken-3);\n}\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n.or-checkbox.is-checked:not(.or-checkbox.is-checked.is-loading):not(.or-checkbox.is-checked.is-disabled):not(.or-checkbox.is-checked.is-readonly):not(.or-checkbox.is-checked:disabled):not(.or-checkbox.is-checked.is-focused):not(.or-checkbox.is-checked:active):hover .or-checkbox--checkbox[data-v-22a147d8] {\n    background-color: var(--c-primary-darken-3);\n    border-color: var(--c-primary-darken-3);\n}\n}\n.or-checkbox.is-checked:not(:disabled):not(.is-loading):not(.is-disabled):not(.is-readonly):active .or-checkbox--checkbox[data-v-22a147d8] {\n  background-color: var(--c-primary-darken-5);\n  border-color: var(--c-primary-darken-5);\n}\n.or-checkbox.is-checked[data-v-22a147d8]:disabled, .or-checkbox.is-checked.is-disabled[data-v-22a147d8] {\n  cursor: not-allowed;\n}\n.or-checkbox.is-checked:disabled .or-checkbox--checkbox[data-v-22a147d8], .or-checkbox.is-checked.is-disabled .or-checkbox--checkbox[data-v-22a147d8] {\n  background-color: var(--c-primary-lighten-20);\n  border-color: var(--c-primary-lighten-20);\n}";
styleInject(css_248z);

script.render = render;
script.__scopeId = "data-v-22a147d8";
script.__file = "src/components/or-checkbox/OrCheckbox.vue";

export { script as s };
